import { Form } from '@ant-design/compatible'

import ManageProductForm from './ManageProductForm'

export default Form.create({
  name: 'productForm',
})(ManageProductForm)
